export const getLineGuideStops = (skipAtShape, stage) => {
  const vertical = [0, stage.width() / 2, stage.width()]
  const horizontal = [0, stage.height() / 2, stage.height()]
  stage
    .find((node) => node.id().startsWith('shape'))
    .forEach((guideItem) => {
      if (guideItem === skipAtShape) {
        return
      }
      const box = guideItem.getClientRect({relativeTo: stage})
      vertical.push([box.x, box.x + box.width, box.x + box.width / 2])
      horizontal.push([box.y, box.y + box.height, box.y + box.height / 2])
    })
  return {
    vertical: vertical.flat(),
    horizontal: horizontal.flat()
  }
}



// WEBPACK FOOTER //
// ./src/components/schemaFonctionnel/helper/getLineGuideStops.js